import { useTranslation } from "react-i18next";

export interface SelectOrgDialogText {
  title: string;
  description: string;
  loadingOrgs: string;
  loadError: string;
  submitError: string;
  noOrgsFound: string;
  selectButton: string;
  cancelButton: string;
}

export const useSelectOrgDialogText = (
  sourceDisplayName: string,
): SelectOrgDialogText => {
  const { t } = useTranslation();

  return {
    title: t("board.connections.selectOrg.title", {
      source: sourceDisplayName,
    }),
    description: t("board.connections.selectOrg.description"),
    loadingOrgs: t("board.connections.selectOrg.loadingOrgs"),
    loadError: t("board.connections.selectOrg.loadError"),
    submitError: t("board.connections.selectOrg.submitError"),
    noOrgsFound: t("board.connections.selectOrg.noOrgsFound"),
    selectButton: t("board.connections.selectOrg.selectButton"),
    cancelButton: t("common.actions.cancel"),
  };
};
